// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__MFv6d","bigColWidth":"Table_bigColWidth__30w78","biggerColWidth":"Table_biggerColWidth__2jNft","row":"Table_row__1WUiA","col":"Table_col__2U1aA"};